import { useMemo } from 'react';
import { useSearchParams } from '@shared/hooks';
import { PRODUCT_IDS_SEARCH_PARAM } from '../constants';

export const useProductIdsSearchParam = (): string[] => {
  const { searchParams } = useSearchParams();
  return useMemo(() => searchParams.getAll(PRODUCT_IDS_SEARCH_PARAM), [searchParams]);
};
